import { render, staticRenderFns } from "./DialogUniversal.vue?vue&type=template&id=8a04b6aa&scoped=true&"
import script from "./DialogUniversal.vue?vue&type=script&lang=ts&"
export * from "./DialogUniversal.vue?vue&type=script&lang=ts&"
import style0 from "./DialogUniversal.vue?vue&type=style&index=0&id=8a04b6aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a04b6aa",
  null
  
)

export default component.exports